<template>
    <v-window-item v-bind="$attrs" transition="scroll-y-transition" reverse-transition="scroll-y-reverse-transition">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-window-item>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
